import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-whitelabel-pending-app-confirm-config',
  templateUrl: './whitelabel-pending-app-confirm-config.component.html',
  styleUrls: ['./whitelabel-pending-app-confirm-config.component.css']
})
export class WhitelabelPendingAppConfirmConfigComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { accountantName: string }, private dialogRef: MatDialogRef<WhitelabelPendingAppConfirmConfigComponent>) {}

  ngOnInit(): void {}

  public onConfirm(): void {
    this.dialogRef.close({
      confirm: true
    })
  }

  public onDismiss(): void {
    this.dialogRef.close(null);
  }
}
